// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1eHdK","nav":"styles_nav__1CGI8","logo":"styles_logo__FcffY","list":"styles_list__2R8eA"};